import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';

interface Segment {
  id: string;
  name: string;
}

interface Type {
  id: number;
  name: string;
  segmentId: string;
  segment: Segment;
}

interface Category {
  id: number;
  name: string;
  typeId: number;
  type: {
    id: number;
    name: string;
    segmentId: string;
  };
}

const fetchTypes = async (): Promise<Type[]> => {
  try {
    const { data } = await api.get<Type[]>('/api/types');
    return data;
  } catch (error) {
    throw new Error('Error al cargar los tipos');
  }
};

const fetchCategories = async (): Promise<Category[]> => {
  try {
    const { data } = await api.get<Category[]>('/api/categories');
    return data;
  } catch (error) {
    throw new Error('Error al cargar las categorías');
  }
};

export const useClassificationOptions = (selectedTypeId?: number | null) => {
  const { data: typeOptions = [] } = useQuery({
    queryKey: ['typeOptions'],
    queryFn: fetchTypes,
  });

  const { data: allCategoryOptions = [] } = useQuery({
    queryKey: ['categoryOptions'],
    queryFn: fetchCategories,
  });

  // Filtrar categorías por el tipo seleccionado
  // Solo filtrar si selectedTypeId es un número válido
  const filteredCategoryOptions = selectedTypeId && selectedTypeId > 0
    ? allCategoryOptions.filter(
        (category) => category.typeId === selectedTypeId
      )
    : [];

  const selectedType = selectedTypeId && selectedTypeId > 0 
    ? typeOptions.find(type => type.id === selectedTypeId)
    : undefined;
    
  const segment = selectedType?.segment?.name || '';

  return {
    typeOptions,
    categoryOptions: filteredCategoryOptions,
    allCategoryOptions,
    segment,
  };
}; 